import type { TextColourEnum } from '../../atoms/Text';
import type { TextDropdownTheme } from './TextDropdown.types';

export const LabelColoursByTheme = {
  light: 'BaseDark',
  dark: 'Charcoal10',
} as const satisfies Record<TextDropdownTheme, TextColourEnum>;
